import $ from 'jquery';
import slick from  '../vendors/slider.min';
import SliderPager from './bjzm-slider-pager.js';

class BjzmScripts {
	
	constructor() {
		 this.do_hamburger();
		 this.doSliders();
		 this.doVideoEmbed();
		 this.doBackgroundVideo();
		 this.isHamburgerOpen = false;
		 this.setTouchScreenClasses(".button, .navigation__link, .pagination__button");
		 this.mobileHeader = $(".header--mobile");
	}

	doBackgroundVideo() {


		$(".hero--home-page .button").on('click', function(e){
			if($('video-is-playing').length > 0){
				console.log('hi')
			}
		});

		$(".hero__video-close-link").on('click', function(e){

			console.log('bye');
		});

	}

	doVideoEmbed() {

		$(".hero--home-page .button").on('click', function(e){
			e.preventDefault();
			$(".hero, .hero__video").addClass('video-is-playing');
			$(".hero--home-page").addClass('video-is-playing');
			$(".scroll__outer").addClass('video-is-playing');

			let $bgVid = document.querySelector('.hero__video-bg');
			let bgPlayer = new Vimeo.Player($bgVid);
			var iframe = document.querySelector('.hero__video iframe');
			var player = new Vimeo.Player(iframe);

			setTimeout(function(){
				player.play().then(function() {
				});
			}, 800);

			$(".hero__video-close-link").unbind('click').on('click', function(){
				$(".hero, .hero__video").removeClass('video-is-playing');
				$(".hero--home-page").removeClass('video-is-playing');
				$(".scroll__outer").removeClass('video-is-playing');

				bgPlayer.play();

				setTimeout(function(){
					player.unload().then(function() {
					});
				}, 800);
			
			});
			
        });

	}


	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		})
	}

	openMobileMenu() {
		this.mobileHeader.addClass("header--mobile-menu-active");
		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		this.mobileHeader.removeClass("header--mobile-menu-active");
		this.isHamburgerOpen = false;
	}


	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	getTouchClass() {
		return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
	}

	setTouchScreenClasses(selectors) {
		var classes = this.getTouchClass();
		$(selectors).addClass( classes );
	}

	doSliders() {
		this.sliders = {};
		if( $(".bjzm-slideshow__list").length > 0 ) {
			
			this.typeSettings = {
				'slider': {
					fade: true,
					speed: 700,
					dots: true,
					autoplay: false,
					slidesToShow: 1,
					infinite: true,
				},
				'events-slider': {
					fade: true,
					dots: true,
					autoplay: false,
					slidesToShow: 1,
					infinite: true,
				},
			}

			$('.bjzm-slideshow__list').each( (index, el) => {
				
				var sliderId = $(el).attr('id');
				var sliderType = $(el).data('slider-type');

				this.sliders[sliderId] = {}
				this.sliders[sliderId].slider = $(el);

				this.sliders[sliderId].slider.slick({ 
					dots: false,
					centerPadding: '0',
			 		slidesToShow: 1,
			 		arrows: false,
		            dotsClass: 'custom_paging',
		            infinite: this.typeSettings[sliderType].infinite,
		            autoplay: false,
		            autoplaySpeed: 3500,
		            useCSS: true,
		            cssEase: 'cubic-bezier(.68,0,.35,1)',
		            fade: this.typeSettings[sliderType].fade,
		            autoplay: this.typeSettings[sliderType].autoplay,
			 	});
			
				$(".bjzm-slideshow__nav-link--prev").on('click', function(e){
					e.preventDefault();
					$(".bjzm-slideshow__list").slick('slickPrev');
				})
			
				$(".bjzm-slideshow__nav-link--next").on('click', function(e){
					e.preventDefault();
					$(".bjzm-slideshow__list").slick('slickNext');
				})

			});	
		} 	
	}
	
}

module.exports = BjzmScripts;